export const USER_LOADING = 'USER_LOADING';

export const USER_READY = 'USER_READY';

export const USER_UPDATE = 'USER_UPDATE';

export const USER_PLAYLIST_POSITION_UPDATE = 'USER_PLAYLIST_POSITION_UPDATE';
